/**
 * 다음 문제 미리보기 조회 훅. 로그인 상태일 때만 요청한다.
 * `GET /app/learning/question/preview`
 *
 * @returns SWR 결과. `data`는 `ProblemPreviewProps`. 비로그인이면 항상 undefined.
 *
 * 로그인 여부를 훅 내부에서 `sessionStorage`로 확인한다(함수 실행 시점 읽기라 prerender 안전).
 */
import api from "pages/api/axiosInstance";
import useSWR from "swr";

export interface ProblemPreviewProps {
  chapterName: string;
  questionTotalCount: number;
  completedQuestionCount: number;
  completedLastChapterDate: string;
  /** 객관식 임시저장 존재 여부. BE 응답에 누락된 환경에서는 undefined. */
  hasTempSave?: boolean;
  /** 챕터 묶음 id(검사 게이트 examRef). BE가 아직 미노출이면 undefined이고 게이트를 건너뛴다. */
  chapterSetId?: number;
}

export function useGetProblemPreview() {
  const isLoggedIn =
    typeof window !== "undefined" &&
    sessionStorage.getItem("accessToken") !== null;

  return useSWR<ProblemPreviewProps>(
    isLoggedIn ? "/app/learning/question/preview" : null,
    (url) => api.get(url).then((res) => res.data.result)
  );
}

export default useGetProblemPreview;
